module.exports = '4.5.2';



// WEBPACK FOOTER //
// ./src/version.js